import Greetings from "./Greetings";
export default Greetings;
